import { VoyagersClubMembershipContainerProps } from '@msc-b2c/interfaces/types';
import { VoyagersClubMembershipContainer } from './VoyagersClubMembershipContainer';
import { RootState, setMembershipJustLinked, scrollToTop } from '@msc-b2c/shared-utils';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';

export function VoyagersClubMembershipContainerWrapper({
  headerTitle,
  description,
  readMore,
  readLess,
  children,
}: Readonly<VoyagersClubMembershipContainerProps>) {
  const dispatch = useDispatch();
  const properties: VoyagersClubMembershipContainerProps = {
    headerTitle,
    description,
    readMore,
    readLess,
    children,
  };

  const membershipData = useSelector((state: RootState) => state.myCruise.membershipData);
  const membershipDataIsLoading = useSelector(
    (state: RootState) => state.myCruise.membershipDataIsLoading
  );
  const membershipJustLinked = useSelector(
    (state: RootState) => state.myCruise.membershipJustLinked
  );

  const hasMemberships =
    !membershipDataIsLoading &&
    membershipData?.memberships !== undefined &&
    membershipData?.memberships?.length > 0;

  useEffect(() => {
    if (membershipJustLinked && hasMemberships) {
      scrollToTop();
      dispatch(setMembershipJustLinked(false));
    }
  }, [membershipJustLinked, hasMemberships, dispatch]);

  if (hasMemberships) {
    return <VoyagersClubMembershipContainer {...properties} />;
  }

  return null;
}

VoyagersClubMembershipContainerWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/voyagersclubmembershipcontainer';

export default VoyagersClubMembershipContainerWrapper;
